import React from 'react';
import classNames from 'classnames';
import { ClickAppIcon, PaymeIcon } from 'icons';

interface IProps {
  setSelectedPayment: React.Dispatch<React.SetStateAction<string | null>>;
  selectedPayment: string | null;
}

const Merchants: React.FC<IProps> = ({ setSelectedPayment, selectedPayment }) => (
  <div className="flex justify-center space-x-4">
    <div
      onClick={() => setSelectedPayment('payme')}
      className={classNames('rounded-xl p-[1px]', {
        'bg-gradient-to-tl from-green-450 to-blue-450': selectedPayment === 'payme'
      })}
    >
      <div className="rounded-xl bg-gray-900">
        <div
          className={classNames('w-35 z-10 flex h-11 cursor-pointer items-center justify-center rounded-xl font-bold', {
            'bg-white/15': selectedPayment === 'payme',
            'border border-white': selectedPayment !== 'payme'
          })}
        >
          <PaymeIcon />
        </div>
      </div>
    </div>
    <div
      onClick={() => setSelectedPayment('click')}
      className={classNames('rounded-xl p-[1px]', {
        'bg-gradient-to-tl from-green-450 to-blue-450': selectedPayment === 'click'
      })}
    >
      <div className="rounded-xl bg-gray-900">
        <div
          className={classNames('w-35 flex h-11 cursor-pointer items-center justify-center rounded-xl font-bold', {
            'bg-white/15': selectedPayment === 'click',
            'border border-white': selectedPayment !== 'click'
          })}
        >
          <ClickAppIcon />
        </div>
      </div>
    </div>
  </div>
);

export default Merchants;
